import { GemType, CommonState } from '@common/types';

export function getGemSpec(gemSpecs: CommonState['gemSpecs'], gemType: GemType) {
  return gemSpecs.find(
    (spec) => spec.kind === gemType.component && spec.componentInfo?.gemId === gemType.componentInfo?.gemId
  );
}
